import { render, staticRenderFns } from "./RaceHeader.vue?vue&type=template&id=0108a0b5&"
import script from "./RaceHeader.vue?vue&type=script&lang=js&"
export * from "./RaceHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports